import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import styles from './index.module.scss';
import Stars from './Stars';
import SGS from './SGS';
import EfSection from '@elem/ui/ef-section';

const JC: React.FC = () => {
    const { t } = useLang('delta3series');

    return (
        <div className={styles.comp} id="d3-C">
            <EcoSpace />
            <EfSection label={t('C_label')} title={t('C_title')} />
            <EcoSpaceSmall />
            <div className="img-box">
                <EcoImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1740646657278/%E5%BF%AB%E5%85%85%20(1).jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1740646634291/%E5%BF%AB%E5%85%85m.jpg"
                />
                <div className="info">
                    <div className="logo">
                        <SGS />
                    </div>
                    <div className="memo">
                        <p className="text">{t('C_text1')}</p>
                        <p className="text">
                            {t('C_text2')}
                            <Stars />
                        </p>
                        <p className="text">{t('C_text3')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default JC;
